export enum NotesAutoGeneration {
  MEETINGS_NOTES = 'meeting-notes',
  USER_MANUAL = 'user-manual',
  POLICY = 'policy',
  STATUS_REPORT = 'status-report',
  TECHNICAL_DOCUMENTATION = 'technical-documentation',
  REQUIREMENTS_DOCUMENTATION = 'requirements-documentation',
  CUSTOM = 'custom-video-context',
}

export enum ParagraphsAutoGeneration {
  Manually = 'manually',
  Automatically = 'automatically',
}

export enum PublishingArticles {
  Manually = 'manually',
  Automatically = 'automatically',
}

export enum NoteTakerMode {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export type BotConfig = {
  companyId: string;
  workspaceId?: string;
  name: string;
  userId: string;
  eventId?: string;
  companySlug?: string;
  customPrompt: string;
  notesAutoGeneration: NotesAutoGeneration | null | string;
  paragraphsAutoGeneration: ParagraphsAutoGeneration;
  publishingArticles: PublishingArticles;
  noteTakerMode?: NoteTakerMode;
};

export const NotesAutoGenerationLabels: Record<NotesAutoGeneration | null, string> = {
  [NotesAutoGeneration.MEETINGS_NOTES]: 'Meeting Notes',
  [NotesAutoGeneration.USER_MANUAL]: 'User Manual',
  [NotesAutoGeneration.POLICY]: 'Policy Document',
  [NotesAutoGeneration.STATUS_REPORT]: 'Status Report',
  [NotesAutoGeneration.TECHNICAL_DOCUMENTATION]: 'Technical Documentation',
  [NotesAutoGeneration.REQUIREMENTS_DOCUMENTATION]: 'Requirements Documentation',
  [NotesAutoGeneration.CUSTOM]: 'Custom',
};

export const ParagraphsAutoGenerationLabels: Record<ParagraphsAutoGeneration, string> = {
  [ParagraphsAutoGeneration.Manually]: 'Manually',
  [ParagraphsAutoGeneration.Automatically]: 'Automatically',
};

export const PublishingArticlesLabels: Record<PublishingArticles, string> = {
  [PublishingArticles.Manually]: 'Manually',
  [PublishingArticles.Automatically]: 'Automatically',
};

export const NoteTakerModeLabels: Record<NoteTakerMode, string> = {
  [NoteTakerMode.Enabled]: 'Enabled',
  [NoteTakerMode.Disabled]: 'Disabled',
};
